export default __webpack_public_path__ + "../staticImages/error404Mobile.webp";